<template>
  <div v-loading="loading" class="agree-list">
    <ul v-if="protocolList.length !== 0 && !loading">
      <li v-for="(item, index) in protocolList" :key="index">
        <div class="flex justify-between items-center bar">
          <div class="flex items-start gap-12">
            <div class="w-8 h-8">
              <div class="dot" :class="String(item.read) === '1' ? '' : 'unread'"></div>
            </div>
            <div :class="String(item.read) === '1' ? '' : 'unread'" class="text">
              {{ item.name }}
            </div>
          </div>
          <el-button
            v-if="!$device.mobile"
            :type="String(item.read) === '1' ? 'default' : 'primary'"
            @click="fun_isArticle(item)"
          >
            {{ String(item.read) === '1' ? $t('productList.confirmed') : $t('productList.tobeconfirmed') }}
          </el-button>
          <el-link v-else :type="String(item.read) === '1' ? 'default' : 'primary'" @click="fun_isArticle(item)">{{
            String(item.read) === '1' ? $t('productList.confirmed') : $t('productList.tobeconfirmed')
          }}</el-link>
        </div>
      </li>
    </ul>
    <noData v-if="protocolList.length === 0 && !loading" />
    <MyArticle :message="childdialogArticle" :save-direct="saveDirect" @read="getRead" />
  </div>
</template>
<script>
import MyArticle from '@/components/dialog/article.vue'
import noData from '@/components/no-data.vue'

export default {
  name: 'Agreement',
  components: {
    MyArticle,
    noData
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    saveDirect: Boolean
  },
  data() {
    return {
      protocolList: [],
      receiveRead: '',
      receiveId: '',
      loading: false,
      childdialogArticle: {}
    }
  },
  mounted() {
    this.get_protocol()
  },
  methods: {
    // 接收弹框传过来的值改变组件内容
    getRead() {
      this.get_protocol()
    },
    fun_isArticle(item) {
      this.childdialogArticle = {
        isDialog: true,
        readTime: new Date(item.time).Format('yyyy-MM-dd HH:mm:ss'),
        ...item
      }
    },
    // 个人信息-协议阅读
    get_protocol() {
      const dbc = this.$global.dbClick
      // eslint-disable-next-line no-useless-call
      dbc.check.call(dbc, 'key')
      this.loading = true
      this.$ajax({
        url: '/user/protocol',
        method: 'get'
      })
        .then(({ data, code }) => {
          dbc.off('key')
          this.loading = false
          if (code !== 0) {
            this.protocolList = []
            return
          } else {
            if (data.protocolList) {
              this.protocolList = data.protocolList
              if (this.protocolList.every((it) => it.read === 1)) {
                this.$emit('readAll')
              }
            } else {
              this.protocolList = []
              return
            }
          }
        })
        .catch((res) => {
          console.error(res)
          dbc.off('key')
          this.loading = false
          this.protocolList = []
        })
    }
  }
}
</script>

<style scoped lang="scss">
.agree-list {
  ul {
    li {
      padding: 16px 24px;
      margin-bottom: 24px;
      background-color: theme('colors.bgColor.module');
      border: 1px solid theme('colors.border');
      border-radius: theme('borderRadius.middle');

      .bar {
        // 移动端
        @include global.response_to(('mobile', 'pad')) {
          & {
            flex-direction: column;
            gap: 28px;
            align-items: flex-start;
          }
        }
      }

      div.text {
        font-family: theme('fontFamily.pingFang');
        font-size: 20px;
        font-weight: 400;
        line-height: 24px;
        color: theme('colors.text.third');
        letter-spacing: 0;

        &.unread {
          color: theme('colors.text.regular');
        }
      }

      .dot {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: theme('colors.text.third');
        border-radius: theme('borderRadius.littlePlus');

        &.unread {
          background: theme('colors.primary');
        }
      }
    }
  }
}
</style>
